import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  buildMakeModelDefaultYear,
  buildModelFamilyIdsModelYearsPath,
  VehicleModel,
  VehicleEntities,
} from 'client/data/models/vehicle-v2';
import { VehicleGraphqlEntities } from 'client/data/models/vehicle-graphql';
import { getFilteredModelYears, getModelYearsWithReview } from 'site-modules/shared/utils/core-page/model-year-helpers';
import { getCurrentYear } from 'site-modules/shared/utils/time-util';
import { YearLinksList } from './year-links-list/year-links-list';

const YEARS_LIMIT = 3;

function OtherReviewYearsUI({
  vehicle: {
    year,
    model: { name: modelName },
    make: { name: makeName },
  },
  modelYears = null,
  defaultYear = null,
  className = null,
  heading = null,
  headingClassName = 'heading-5 mb-0_75',
  isMobile = false,
  hasSpeculationRule = false,
}) {
  const allModelYears = useMemo(() => {
    const currentYear = parseInt(getCurrentYear(), 10);
    return getModelYearsWithReview(
      getFilteredModelYears(modelYears, modelName).filter(
        ({ year: modelYear }) => parseInt(modelYear, 10) > currentYear - YEARS_LIMIT
      ),
      defaultYear
    );
  }, [modelYears, modelName, defaultYear]);

  return (
    <YearLinksList
      years={allModelYears}
      currentYear={year}
      makeName={makeName}
      modelName={modelName}
      className={className}
      heading={heading}
      headingClassName={headingClassName}
      isMobile={isMobile}
      hasSpeculationRule={hasSpeculationRule}
    />
  );
}

OtherReviewYearsUI.propTypes = {
  vehicle: VehicleGraphqlEntities.Vehicle.isRequired,
  modelYears: PropTypes.arrayOf(VehicleEntities.ModelYearByFamilyId),
  defaultYear: PropTypes.number,
  className: PropTypes.string,
  heading: PropTypes.string,
  headingClassName: PropTypes.string,
  isMobile: PropTypes.bool,
  hasSpeculationRule: PropTypes.bool,
};

export const OtherReviewYears = connectToModel(OtherReviewYearsUI, {
  defaultYear: bindToPath(
    ({ vehicle }) => buildMakeModelDefaultYear({ make: vehicle.make.slug, model: vehicle.model.slug }),
    VehicleModel
  ),
  modelYears: bindToPath(({ vehicle }) => buildModelFamilyIdsModelYearsPath(vehicle.modelFamilyIds), VehicleModel),
});
